import { GlobalStyles as MUIGlobalStyles } from "@mui/material"

export default function GlobalStyles() {
  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={(theme) => {
        return {
          "*": {
            boxSizing: "border-box",
          },
          html: {
            margin: 0,
            padding: 0,
            width: "100%",
            height: "100%",
            WebkitOverflowScrolling: "touch",
          },
          body: {
            margin: 0,
            padding: 0,
            width: "100%",
            height: "100%",
            overflowY: "scroll",
          },
          "#root": {
            width: "100%",
            height: "100%",
            backgroundColor: theme.palette.background.default,
          },
          input: {
            "&[type=number]": {
              MozAppearance: "textfield",
              "&::-webkit-outer-spin-button": {
                margin: 0,
                WebkitAppearance: "none",
              },
              "&::-webkit-inner-spin-button": {
                margin: 0,
                WebkitAppearance: "none",
              },
            },
          },
          img: {
            display: "block",
            maxWidth: "100%",
          },
          ul: {
            margin: 0,
            padding: 0,
          },
          mark: {
            background:
              theme.palette.mode === "light"
                ? `linear-gradient(180deg,rgba(255,255,255,0) 00%, ${theme.palette.primary.light} 100%)`
                : theme.palette.primary.dark,

            borderRadius: "0.25em",
            fontWeight: "bold",
            color: theme.palette.text.primary,
          },
        }
      }}
    />
  )

  return inputGlobalStyles
}
